import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'

import { getUnifiedShipments } from './unifiedShipments.service'
import { BookingSchema } from '../domain/booking'
import { HouseShipmentSchema } from '../domain/houseShipment'
import { ShipmentPageParams } from '../types'

const pageSize = 20

const getFilteredUnifiedShipments = async ({ pageParam }: { pageParam: Partial<ShipmentPageParams> }) => {
  const { items, totalItems, totalPages } = await getUnifiedShipments({ pageParam })
  const overviewItems = items.map((item) => {
    try {
      return {
        shipment: item.shipment ? HouseShipmentSchema.parse(item.shipment) : null,
        booking: item.booking ? BookingSchema.parse(item.booking) : null,
      }
    } catch (error) {
      /* eslint-disable no-console */
      if (error instanceof z.ZodError) {
        console.error(`ZOD Error in house shipment parse: ${item.shipment?.code}`, error.issues)
      } else {
        console.error(`Error in house shipment parse: ${item.shipment?.code || item.booking?.id}`, error)
      }
      return null
    }
  })
  return {
    items: overviewItems,
    totalItems,
    totalPages,
  }
}

export const unifiedShipmentsQueryOptions = (
  queryParams?: Partial<ShipmentPageParams>,
  shipmentRequired?: boolean,
  bookingRequired?: boolean,
  enabled = true
) => {
  const { query = '', ...restQueryParams } = queryParams || {}
  const initialPageParams: ShipmentPageParams = {
    limit: pageSize,
    offset: 0,
    orderBy: 'relevance',
    orderByDesc: true,
    query,
    shipmentRequired,
    bookingRequired,
    ...restQueryParams,
  }

  // Check and prevent empty search strings due to leading to empty result list
  if (query) {
    initialPageParams.query = query
  }

  return queryOptions({
    queryKey: ['unifiedShipments', shipmentRequired, bookingRequired, initialPageParams],
    queryFn: () => getFilteredUnifiedShipments({ pageParam: initialPageParams }),
    enabled,
  })
}
